"use strict";

exports.__esModule = true;
var _ChangePartKindActionElement = require("./ChangePartKindActionElement");
Object.keys(_ChangePartKindActionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChangePartKindActionElement[key]) return;
  exports[key] = _ChangePartKindActionElement[key];
});
var _action = require("./action");
Object.keys(_action).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _action[key]) return;
  exports[key] = _action[key];
});